<template>
  <card-layout :animation-delay="animationDelay" @go="go()" :show-card-btn="true">
    <div class="section-2-1 mb-0">
      <div>
        <div :class="{statusText: 'mb-normal'}">
          <p class="color-blue-light">Дата исследования</p>
          <h2 class="h3">{{ item.short.regdate }}</h2>
        </div>
      </div>
      <div v-if="statusText" class="mb-small">
        <p class="color-blue-light">Статус:</p>
        <h4 class="h3"><text-skeleton type="heading" :text="statusText"></text-skeleton> </h4>
      </div>
    </div>
  </card-layout>
</template>

<script>
import { LabData } from "@/store/userLabs";
import { computed } from "vue";
import CardLayout from "@/layouts/CardLayout";
import { useRouter } from "vue-router";
import TextSkeleton from "@/components/TextSkeleton";
import {apiService} from "@/services/api/apiService";
import {notifyError} from "@/plugins/notification";

export default {
  name: "LabsCard",
  props: {
    item: { type: Object, validator: (o) => o instanceof LabData },
    animationDelay: { type: Number, default: 0 },
    manualGo: { type: Boolean, default: false },
  },
  components: {
    CardLayout,TextSkeleton,
  },
  emits: ["go"],
  setup(props, { emit }) {
    const router = useRouter();

    return {
      go: () => {
        const id = props.item.short.research_id;

        emit("go", id);
        if (!props.manualGo) {
          router.push({
            name: `labs-card`,
            params: { id: `${id}` },
          });
        }


        // apiService
          //     .send({
          //         endpoint: `/pdf/${id}`,
          //         method: "get",
          //         headers: {
          //             downloadFormat: 'pdf'
          //         },
          //         responseType: 'blob'
          //     })
          //     .then(res => {
          //         console.log('res', res);
          //         if (res?.type === "application/pdf") {
          //
          //             // const url = window.URL.createObjectURL(res);
          //             // const link = document.createElement('a');
          //             //
          //             // link.href = url;
          //             // link.download = `${typeIdReq.value.typeRes}_${typeIdReq.value.id}.pdf`;
          //             // link.click();
          //             //
          //             // window.URL.revokeObjectURL(url);
          //         } else {
          //             notifyError("Ошибка скачивания");
          //         }
          //
          //         // isLoading.value = false;
          //     })
          //     .catch(err => {
          //         notifyError("Ошибка скачивания");
          //         console.log('err', err)
          //         // isLoading.value = false;
          //     })
      },
      statusText: computed(() => {
        if (props.item.short.text_status) return props.item.short.text_status;
        let status = "";
        props.item.full.find(({labResearchInfo: {text_status}}) => {
          if (text_status !== status) {

            if (!status) {
              status = text_status
              return false;
            }
            status = 'в процессе';
            return true;
          }
        });
        return status;
      })
    };
  },
};
</script>

<style scoped>
.labs-card-research {
  height: 72px;
  overflow: hidden;
  min-width: 224px;
}
</style>
